import state from './pageState'

export default{
  PAGE_STATE: state,
}